import HelloWorld from "./components/HelloWorld";

const App = () => {
  return (
    <div>
      <HelloWorld />
    </div>
  );
}

export default App;
